import * as React from 'react';
import {
  Activity,
  BarChart3,
  Beaker,
  Building2,
  Clock3,
  Repeat,
  FolderOpen,
  GitBranch,
  Globe,
  HardDrive,
  Layers,
  ListTodo,
  Package,
  Plug2,
  Settings,
  Shield,
  Star,
  Terminal,
} from 'lucide-react';
import type { InspectorTabId } from './panes';

// REQ-045 — the TilingBar strip is gone; this module keeps only TAB_ICONS
// (shared by the pane tab strip in pane.tsx). Tool buttons live on the
// Inspector rail, splits on the pane strip.

export const TAB_ICONS: Record<InspectorTabId, React.ReactNode> = {
  // REQ-043 — Files page icon (open folder; Vault keeps the closed Folder).
  files: <FolderOpen className="h-3 w-3" />,
  providers: <Plug2 className="h-3 w-3" />,
  models: <Layers className="h-3 w-3" />,
  usage: <BarChart3 className="h-3 w-3" />,
  settings: <Settings className="h-3 w-3" />,
  terminal: <Terminal className="h-3 w-3" />,
  git: <GitBranch className="h-3 w-3" />,
  browser: <Globe className="h-3 w-3" />,
  // REQ-163/164/165/166 — Agent Hub, Orchestration, Vault, Memory and
  // Skills left the pane registry (Settings modal sections); REQ-167 —
  // Archify left too (standalone modal, no pane tab icon needed); REQ-168 —
  // Design is its own page, so it has no pane tab icon either.
  testing: <Beaker className="h-3 w-3" />,
  auth: <Shield className="h-3 w-3" />,
  setup: <HardDrive className="h-3 w-3" />,
  plugins: <Package className="h-3 w-3" />,
  observability: <Activity className="h-3 w-3" />,
  cron: <Clock3 className="h-3 w-3" />,
  loops: <Repeat className="h-3 w-3" />,
  // REQ-204 — the Office pane tab (a pixel office reads as a building).
  office: <Building2 className="h-3 w-3" />,
  extras: <Star className="h-3 w-3" />,
  todos: <ListTodo className="h-3 w-3" />,
};
